import React from "react";
import iconUnavailable from "../../assets/icon_unavailable.svg";
import Button from "../Buttons/Button";
import { useNavigate } from "react-router-dom";

const ServiceUnavailable = ({
  title,
  description,
  button = "서비스 재시작",
}) => {
  const navigate = useNavigate();
  const link = "/landing";
  const handleOnClick = () => {
    navigate(link);
  };
  return (
    <div className="flex flex-col items-center justify-center h-dvh">
      <div className="mb-3">
        <img src={iconUnavailable} alt="Service Unavailable" />
      </div>
      <h1 className="mb-5 text-2xl font-semibold">{title}</h1>
      <p className="font-medium text-center text-neutral-400">{description}</p>
      <div className="fixed left-0 w-full bottom-10 p-inner">
        <Button onClick={handleOnClick}>{button}</Button>
      </div>
    </div>
  );
};

export default ServiceUnavailable;
